<!-- Login section -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<section class="login-page section-b-space">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">


        <div class="theme-card">
          <h3 class="title-font">Solent Express Login</h3>
          <p>Nationwide, service for flooring materials and sundries.</p>
          <br /><br />
          <form class="theme-form" name="form" [formGroup]="userLoginForm">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="text" class="form-control" autocomplete="off"
                placeholder="Email" formControlName="username"
                name="username"  required>
            </div>
            <div class="form-group">
              <label for="review">Password</label>
              <input type="password" class="form-control" autocomplete="off"
                placeholder="Enter your password"
                required name="password" formControlName="password" >
            </div>
            @if (formError) {
              <h4 class="redtext">** {{formError}} **</h4>
            }
            <button (click)="login()" class="btn primary-btn btn-default radius-0">
              Login
            </button>

            <a [routerLink]="['/page/new-customer']" class="btn primary-btn btn-default radius-0">
              Register
            </a>
          </form>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="theme-card authentication-right">
          <h3 class="title-font">Don't have an account?</h3>
          <p>We are a trade only supplier, we do not list prices on our website without logging in for this reason!
            <br /><br />
            If you are in the Trade and would like to purchase some of our products, please fill out our quick and easy
            application form, once processed you will be able to order directly on this website, or via our sales office.
            <br /><br />
            If you prefer to speak to our office, please give us a call on <a href="tel:01243774623">01243 774623</a> and we would be happy to help with
          any query you may have.</p>
          <br />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- end Login section -->

